import { Lock } from "lucide-react";
import { useSiteContent } from "@/lib/siteContent";

type Props = {
    /** true = weißer Text auf dunklem Grund (für dunkle Zonen). */
    dark?: boolean;
};

/**
 * Diskretions-Statement (editierbar über Site-Content-CMS).
 * Keys: `discretion_headline`, `discretion_body`.
 */
export default function DiscretionSection({ dark = false }: Props) {
    const { get } = useSiteContent();
    const headline = get<string>("discretion_headline", "Absolute Diskretion.");
    const body = get<string>(
        "discretion_body",
        "Übergabe Ihrer privaten Daten ausschließlich auf Ihrem persönlichen Speichermedium.",
    );

    const goldLine = "hsl(var(--hf-gold))";
    const inkText = dark ? "hsl(var(--hf-bg))" : "hsl(var(--hf-ink))";
    const muted = dark ? "hsl(var(--hf-bg) / 0.85)" : "hsl(var(--hf-muted))";

    return (
        <section
            className="py-24 md:py-32"
            style={dark ? { background: "hsl(var(--hf-ink))" } : undefined}
            data-testid="discretion-section"
        >
            <div className="max-w-3xl mx-auto px-6 text-center">
                <div
                    className="mx-auto"
                    style={{ width: 96, height: 1, background: goldLine }}
                    aria-hidden
                />
                <div
                    className="mx-auto mt-8 mb-8 inline-flex items-center justify-center rounded-full"
                    style={{
                        width: 52,
                        height: 52,
                        background: dark ? "hsl(var(--hf-gold) / 0.14)" : "hsl(var(--hf-gold-soft) / 0.4)",
                        border: `1px solid ${goldLine}`,
                    }}
                    data-testid="discretion-icon"
                >
                    <Lock size={20} style={{ color: "hsl(var(--hf-gold-dark))" }} />
                </div>
                <h2
                    className="font-display text-3xl sm:text-4xl md:text-5xl leading-[1.1]"
                    style={{ color: inkText }}
                    data-testid="discretion-headline"
                >
                    {headline}
                </h2>
                <p
                    className="mt-6 text-base md:text-lg leading-relaxed"
                    style={{ color: muted }}
                    data-testid="discretion-body"
                >
                    {body}
                </p>
                <div
                    className="mx-auto mt-10"
                    style={{ width: 96, height: 1, background: goldLine }}
                    aria-hidden
                />
            </div>
        </section>
    );
}
